import React, { useEffect, useState } from "react";

function CustomAlert({ message, type = "success", onClose }) {
  const [isVisible, setIsVisible] = useState(false);

  // Map your custom types to Bootstrap alert classes
  const getBootstrapType = (type) => {
    switch (type) {
      case 'error':
        return 'danger';
      case 'success':
        return 'success';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      default:
        return 'info';
    }
  };

  // Handle slide-in on mount and slide-out on dismiss
  useEffect(() => {
    if (message) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 4500); // Slightly less than 5s to allow slide-out animation
      return () => clearTimeout(timer);
    }
  }, [message]);

  // Handle animation end to call onClose
  useEffect(() => {
    if (!isVisible && message) {
      const timer = setTimeout(() => {
        onClose();
      }, 500); // Match animation duration
      return () => clearTimeout(timer);
    }
  }, [isVisible, message, onClose]);

  if (!message) return null;

  const bootstrapType = getBootstrapType(type);

  return (
    <div
      className={`alert alert-${bootstrapType} alert-dismissible fade show d-flex align-items-center`}
      role="alert"
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        zIndex: 1050,
        minWidth: "300px",
        maxWidth: "400px",
        transform: isVisible ? "translateX(0)" : "translateX(100%)",
        transition: "transform 0.5s ease-in-out",
      }}
    >
      <div>{message}</div>
      <button
        type="button"
        className="btn-close"
        onClick={() => setIsVisible(false)}
        aria-label="Close"
        style={{ marginLeft: "auto" }}
      ></button>
    </div>
  );
}

export default CustomAlert;